module.exports = __webpack_public_path__ + "img/nc-central-logo.b0c84a97.jpg";